// Auth ACTIONS TYPES
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS';
export const UPDATE_MSAL = 'UPDATE_MSAL';
export const UPDATE_STAY_SIGN_IN = 'UPDATE_STAY_SIGN_IN';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_USER_CREDITS = 'UPDATE_USER_CREDITS';
